import { useQuery } from '@tanstack/react-query'
import { EntityWithIdAndDescription, SectorComercial, UnidadNegocio } from '../../../../../types'
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion'
import { OperacionAFOUnidadNegocio, OperacionAFOSectorComercial } from '../types/dto'

export const useAFOPUUnidadNegocioTipos = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: unidadNegocioTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<UnidadNegocio[], Error>({
        queryKey: ['AFOPU-unidad-negocio-tipos', codPais, codSistema],
        queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
        enabled: !!codPais && !!codSistema
    })

    return {
        unidadNegocioTipos,
        isLoading,
        isError,
        error
    }
}

export const useAFOPUSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: sectorComercialTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<SectorComercial[], Error>({
        queryKey: ['AFOPU-sector-comercial-tipos', codUnidadNegocio, codSistema],
        queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
        enabled: !!codUnidadNegocio && !!codSistema
    })

    return {
        sectorComercialTipos,
        isLoading,
        isError,
        error
    }
}


export const useAFOPUAforoTipos = (codPais: number | undefined | null) => {
    const {
        data: aforoTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['AFOPU-aforo-tipos', codPais],
        queryFn: () => HttpCacheOperacion.getAFOPUAforoTipos(codPais!),
        enabled: !!codPais
    })

    return {
        aforoTipos,
        isLoading,
        isError,
        error
    }
}